import { createFileRoute } from "@tanstack/react-router"
import { Vacations } from "../../components/Vacation/Vacations"

export const Route = createFileRoute("/_layout/vacations")({
    component: Vacations,
})